import React, {Fragment, useContext} from 'react'
import {AppContext} from '../app/app'
import Config from '../launch/config'

import './event-log.css'

const EventLog = () => {
    const {eventLog, isGameLoading} = useContext(AppContext)

    if (isGameLoading) {
        return null
    }

    return (
        <Fragment>
            {eventLog.map((props, index) => {
                if (!props) {
                    return null
                }

                const {coords, html} = props

                if (index < eventLog.length - 1) {
                    return null
                }

                return (
                    <div
                        className="event-log__message"
                        dangerouslySetInnerHTML={{
                            __html: html,
                        }}
                        key={index}
                        onClick={() => {
                            Config.scene.cameras.main.pan(
                                coords.x,
                                coords.y,
                                300,
                                'Linear',
                                true
                            )
                        }}
                    />
                )
            })}
        </Fragment>
    )
}

export default EventLog
